/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppTemplateStorePathParams,
	WhatsAppTemplateStoreRequest,
	WhatsAppTemplateStoreResponse,
} from '../types/WhatsAppTemplateStore'

/**
 * POST /organisations/:organisationId/whatsapp-templates
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::store
 */
export async function whatsAppTemplateStore(
	organisationId: WhatsAppTemplateStorePathParams['organisationId'],
	data: WhatsAppTemplateStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppTemplateStoreResponse>> {
	return axiosInstance.post(`/organisations/${organisationId}/whatsapp-templates`, data, config)
}
